<a class="media-none" *ngIf="media.type === 'NONE'" (click)="onClick($event)">
    <img src="https://static.myskillcamp.com/images/icon/icon-camp/icon_library_fichiers.svg" />

    <div class="media-none__desc">
        <p class="media-none__name">{{ media.title | truncate: '14' }}</p>
        <p class="media-none__size">{{ media.size | fileSize }} <span>{{ 'words.edited' | translate }} {{ media.updatedAt | date : 'dd-MM-yyyy' }}</span></p>
    </div>
</a>
